import ValueSuggestionsList from './ValueSuggestionsList';

export default ValueSuggestionsList;